import { createSlice } from '@reduxjs/toolkit'

type Compensation = {
    uuid: string, 
    isVariable: boolean, 
    compensationType: string, 
    compensationSubType: string, 
    index: number,
    formulaBasedOn: string,
}

const initialState = {
    refresh: false,
    slug: "",
    status: "",
    compensation : <Compensation | null > null
}

export const compensationReducerSlice = createSlice({
    name: 'compensation/compensation',
    initialState,
    reducers: {
        setRefresh: (state, action) => {
            return { ...state, ...action.payload };
        }
    }
})

export const { setRefresh } = compensationReducerSlice.actions;
export default compensationReducerSlice.reducer